{
  "0_ALREADY_EXISTS": "\"{0}\" esiste già.",
  "0_OF_1": "{0} di {1}",
  "ACCOUNT_ID": "ID account",
  "ADD": "Aggiungi",
  "ADD_REMOVE_FIELDS": "Aggiungi/rimuovi campi",
  "AN_ERROR_OCCURED": "Si è verificato un errore",
  "APPLY": "Applica",
  "APPLY_CHANGES": "Applica modifiche",
  "ATTACH": "Allega",
  "ATTACH_AS_LINK": "Allega come collegamento",
  "ATTACHING": "Allegando...",
  "AUTOMATICALLY_RENAME": "Rinomina automaticamente",
  "BACK": "Indietro",
  "BROWSE": "Sfoglia",
  "CANCEL": "Annulla",
  "CHARACTER_COUNT": "Conteggio caratteri:",
  "CLOSE": "Chiudi",
  "CLOUD": "Cloud",
  "COMMENT": "Commento",
  "CONFIGURE_REPOSITORY_SETTINGS": "Configura impostazioni repository",
  "COULD_NOT_SAVE_0": "Impossibile salvare \"{0}\".",
  "COULD_NOT_SAVE_0_FILE_TYPE_NOT_SUPPORTED": "Impossibile salvare \"{0}\". Tipo di file non supportato.",
  "DATA": "Dati",
  "DATE": "Data",
  "DATE_FIELDS_MUST_BE_IN_FORMAT_0": "I campi data devono essere nel formato {0}.",
  "DATE_PROVIDED_IS_INVALID": "La data fornita non è valida.",
  "DATE_TIME": "Data/Ora",
  "DATE_TIME_FIELDS_MUST_BE_IN_FORMAT_0": "I campi data/ora devono essere nel formato {0}.",
  "DEFAULT_FOLDER": "<Cartella predefinita>",
  "DETAILS": "Dettagli",
  "DO_YOU_WANT_TO_APPLY_YOUR_FIELD_CHANGES": "Vuoi applicare le modifiche ai campi?",
  "DOCUMENT_NAME_IS_EMPTY": "Il nome del documento è vuoto",
  "DRAG_DROP_FILE": "Trascina e rilascia il file",
  "ENTRY_0_ALREADY_EXISTS_SELECT_DIFFERENT_NAME": "Una voce chiamata '{0}' esiste già in questa cartella. Seleziona un nome diverso.",
  "ENTRY_ID": "ID voce",
  "ENTRY_NAME": "Nome voce",
  "ENTRY_NOT_FOUND": "Voce non trovata.",
  "ERROR_DOWNLOADING_DOCUMENT": "Errore durante il download del documento.",
  "ERROR_OCCURRED_WHILE_CONNECTING_TO_SERVER": "Si è verificato un errore durante la connessione al server.",
  "ERROR_SAVING": "Errore durante il salvataggio:",
  "FAILED_TO_OPEN_FOLDER": "Impossibile aprire la cartella",
  "FAILED_TO_SAVE_COLON": "Salvataggio non riuscito:",
  "FAILED_TO_SAVE_PERIOD": "Salvataggio non riuscito.",
  "FEEDBACK": "Feedback",
  "FIELDS": "Campi",
  "FILE_EXCEEDS_MAXIMUM_FILE_SIZE_25MB": "Questo file supera la dimensione massima consentita di 25MB.",
  "FILE_EXTENSION": "Estensione file",
  "FILE_LOCKED": "Il file è bloccato.",
  "FILE_MODIFIED": "File modificato",
  "FILE_NAME": "Nome file",
  "FILENAMES_CANNOT_CONTAIN_BACKSLASH": "I nomi dei file non possono contenere una barra rovesciata",
  "FOLDER": "Cartella",
  "INTEGER": "Intero",
  "LIST": "Elenco",
  "LOADING": "Caricamento in corso...",
  "LONG_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_3999999999": "I campi long devono essere numeri interi tra 0 e 3.999.999.999",
  "LONG_INTEGER": "Intero lungo",
  "NAME": "Nome",
  "NAME_CONFLICT": "Conflitto di nome",
  "NEED_HELP_SIGNING_IN_CONTACT_LASERFICHE_ADMINISTRATOR_FOR_HELP": "Hai bisogno di aiuto per accedere? Contatta l'amministratore Laserfiche per assistenza.",
  "NEW_FOLDER": "Nuova cartella",
  "NO": "No",
  "NO_ADDITIONAL_FIELDS_ASSIGNED": "Nessun campo aggiuntivo assegnato",
  "NO_FOLDER_SELECTED": "Nessuna cartella selezionata.",
  "NO_MATCHING_ENTRIES_FOUND": "Nessuna voce corrispondente trovata",
  "NO_MATCHING_FIELDS_FOUND": "Nessun campo corrispondente è stato trovato.",
  "NO_TEMPLATE_ASSIGNED": "Nessun modello assegnato",
  "NOT_AVAILABLE_WITH_TOKENS": "Non disponibile con i token",
  "NUMBER": "Numero",
  "NUMBER_FIELD_MUST_BE_VALID_NUMBER": "Il campo numero deve essere un numero valido",
  "OK": "Ok",
  "ONE_OR_MORE_FIELDS_INVALID": "Uno o più campi non sono validi.",
  "OPEN": "Apri",
  "OPEN_IN_LASERFICHE": "Apri in Laserfiche",
  "OPTIONAL": "Opzionale",
  "OR": "o",
  "PARENT_FIELD": "Campo genitore",
  "PARENT_ID": "ID genitore",
  "PARENT_NAME": "Nome genitore",
  "PLEASE_SELECT_A_FOLDER": "Selezionare una cartella",
  "REASON_FOR_DOWNLOADING": "Motivo del download",
  "REFRESH": "Aggiorna",
  "REMOVE": "Rimuovi",
  "REMOVE_REPOSITORY": "Rimuovere il repository?",
  "REPOSITORY": "Repository",
  "REPOSITORY_COUNT": "Conteggio repository",
  "REPOSITORY_ID": "ID repository",
  "REPOSITORY_NAME": "Nome repository",
  "REQUIRED": "Obbligatorio",
  "REQUIRED_FIELD_IS_EMPTY": "Il campo obbligatorio è vuoto",
  "SAVE_CHANGES": "Salva modifiche",
  "SAVE_TO_LASERFICHE": "Salva in Laserfiche",
  "SAVED_TO_LASERFICHE": "Salvato in Laserfiche",
  "SAVED_TO_LASERFICHE_COLON": "Salvato in Laserfiche:",
  "SAVED_WITH_MISSING_METADATA": "Salvato con metadati mancanti:",
  "SAVING": "Salvataggio in corso...",
  "SEARCH_FIELDS": "Campi di ricerca",
  "SELECT": "Seleziona",
  "SELECT_REASON": "Seleziona un motivo",
  "SELF_HOSTED": "Self-Hosted",
  "SESSION_COUNT": "Conteggio sessioni",
  "SETTINGS": "Impostazioni",
  "SHORT_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_64999": "I campi short devono essere numeri interi tra 0 e 64999",
  "SIGN_IN": "Accedi",
  "SIGN_IN_TO_LASERFICHE": "Accedi a Laserfiche",
  "SIGN_OUT": "Disconnetti",
  "SIGNING_IN": "Accesso in corso...",
  "SIGNING_OUT": "Disconnessione in corso...",
  "SKIP_THIS_FILE": "Salta questo file",
  "SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER": "Si è verificato un errore. Riprova più tardi.",
  "SUBMIT": "Invia",
  "SUGGESTION": "Suggerimento",
  "TEMPLATE": "Modello",
  "TEMPLATE_HAS_FAILED_TO_LOAD": "Il modello non è stato caricato.",
  "TEXT": "Testo",
  "THANK_YOU_FOR_SUBMISSION": "Grazie per la tua segnalazione!",
  "THIS_FIELD_HAS_MAXIMUM_ALLOWED_LENGTH_0_CHARACTERS": "Questo campo ha una lunghezza massima consentita di {0} caratteri.",
  "THIS_FOLDER_IS_EMPTY": "Questa cartella è vuota.",
  "TIME": "Ora",
  "TIME_FIELDS_MUST_BE_IN_FORMAT_0": "I campi orario devono essere nel formato {0}.",
  "UNABLE_TO_LOAD_ALL_FIELDS": "Impossibile caricare tutti i campi:",
  "UNABLE_TO_RETRIEVE_REPOSITORY_INFORMATION": "Impossibile recuperare le informazioni del repository:",
  "UNKNOWN_ERROR": "Errore sconosciuto.",
  "USER_NAME": "Nome utente",
  "YES": "Sì"
}
